import { browserBugFilters } from './filters/browserBugs';
import { extensionBugFilters } from './filters/extensionBugs';
import { thirdPartyBugFilters } from './filters/thirdPartyBugs';
import { SentryFilter } from './types';

export const allFilters: SentryFilter[] = [
  ...browserBugFilters,
  ...extensionBugFilters,
  ...thirdPartyBugFilters,
]